<template>
  <CDropdown
    ref="notfDropdown"
    placement="bottom-end"
    :caret="false"
    class="c-header-nav-item notification-dropdown me-3"
  >
    <CDropdownToggle class="p-0 border-0">
      <div
        class="notification-icon d-flex align-items-center p-0 ms-1 me-1"
        @click="seenNotifications"
      >
        <span class="notification-bell-icon" />
        <div
          v-if="notSeen.length"
          class="notification-badge bg-accent-blue-dark"
        >
          {{ notSeen.length > 9 ? "9+" : notSeen.length }}
        </div>
      </div>
    </CDropdownToggle>
    <CDropdownMenu
      data-test-id="notification-center-list"
      class="user-notifications-dropdown pt-0 pb-0"
    >
      <div
        v-if="notifications.length"
        class="user-notifications-list px-3 py-4"
      >
        <CDropdownItem
          v-for="(notification, index) in notifications"
          :key="index"
          :style="`background-color:${
            notification.seen_at
              ? '#e3e3e3'
              : colors[notification.notification_type]
          }`"
        >
          <div>
            <div v-if="notification.notification_type != 'time_change'">
              <span
                class="notification-text-holder"
                :style="`background-color:${
                  notification.seen_at
                    ? '#fff'
                    : colors[notification.notification_type]
                }; color:${notification.seen_at ? '#000' : '#fff '}`"
                >CANCELED</span
              >Your pass to
              <strong>{{
                notification.appointment_pass.to.name
                  ? notification.appointment_pass.to.name
                  : notification.appointment_pass.to.first_name +
                    " " +
                    notification.appointment_pass.to.last_name
              }}</strong>
              at<strong style="word-break: keep-all; white-space: nowrap">
                {{
                  $helpers.transformDate(
                    notification.appointment_pass.for_date,
                    "h:mm A"
                  )
                }}</strong
              >
              for
              {{
                $helpers.transformDate(notification.appointment_pass.for_date)
              }}
              has been
              {{
                notification.notification_type == "time_change"
                  ? "moved"
                  : notification.notification_type
              }}
              by
              <strong
                >{{
                  notification.updated_by
                    ? notification.updated_by.first_name +
                      " " +
                      notification.updated_by.last_name
                    : "Somebody"
                }}.</strong
              >
            </div>
            <div v-if="notification.notification_type == 'time_change'">
              <span
                class="notification-text-holder"
                :style="`background-color:${
                  notification.seen_at
                    ? '#fff'
                    : colors[notification.notification_type]
                };`"
                >EDITED</span
              >Your pass to
              <strong>{{
                notification.appointment_pass.to.name
                  ? notification.appointment_pass.to.name
                  : notification.appointment_pass.to.first_name +
                    " " +
                    notification.appointment_pass.to.last_name
              }}</strong>
              at<strong style="word-break: keep-all; white-space: nowrap">
                {{
                  $helpers.transformDate(notification.old_time, "h:mm A")
                }}</strong
              >
              for {{ $helpers.transformDate(notification.old_time) }} has been
              <strong
                >moved at
                {{ $helpers.transformDate(notification.new_time, "h:mm A") }}
                for {{ $helpers.transformDate(notification.new_time) }}</strong
              >
              by
              <strong
                >{{
                  notification.updated_by
                    ? notification.updated_by.first_name +
                      " " +
                      notification.updated_by.last_name
                    : "Somebody"
                }}.</strong
              >
            </div>
          </div>
        </CDropdownItem>

        <button
          class="btn mt-3 action-btn text-white py-2 px-4 fw-bold"
          @click="clearNotifications()"
        >
          Clear all notifications
        </button>
      </div>
    </CDropdownMenu>
  </CDropdown>
</template>
<script>
import { mapGetters } from "vuex"
export default {
  name: "TheHeaderDropdownNotif",
  data() {
    return {
      colors: {
        created: "#4a7cab",
        canceled: "#8a8fdf",
        time_change: "#efd4bc"
      }
    }
  },
  created() {
    this.$store.dispatch("sockets/getNotifications")
  },
  computed: {
    ...mapGetters({
      notifications: "sockets/notifications"
    }),
    notSeen() {
      return this.notifications.filter((e) => !e.seen_at)
    }
  },
  methods: {
    clearNotifications() {
      this.$store.dispatch("sockets/clearNotifications")
    },
    seenNotifications() {
      this.$store.dispatch("sockets/getNotifications").then(() => {
        const notifications = []
        this.notSeen.forEach((e) => {
          notifications.push(e.id)
        })
        if (notifications.length > 0) {
          this.$store.dispatch("sockets/bulkSeenNotifications", {
            notifications: notifications
          })
        }
      })
    }
  }
}
</script>

<style scoped></style>
